/**
 * Zondela Traveler Gallery
 * Horizontal photo carousel with manual arrow navigation, smooth scrolling,
 * native touch swipe (via overflow-x + scroll-snap) and disabled states
 * at the start/end of the track.
 */
(function () {
  function initCarousel(section) {
    var track = section.querySelector('[data-ztg-track]');
    var prevBtn = section.querySelector('[data-ztg-prev]');
    var nextBtn = section.querySelector('[data-ztg-next]');

    if (!track || !prevBtn || !nextBtn) return;
    if (track.dataset.ztgInitialized === 'true') return;
    track.dataset.ztgInitialized = 'true';

    var rafId = null;

    function getStep() {
      var slide = track.querySelector('[data-ztg-slide]');
      if (!slide) return track.clientWidth;

      var gap = parseFloat(getComputedStyle(track).gap) || 0;
      return slide.getBoundingClientRect().width + gap;
    }

    function updateControls() {
      var maxScroll = track.scrollWidth - track.clientWidth;
      var scrollLeft = track.scrollLeft;
      var tolerance = 1;

      // RTL-safe: some browsers report negative scrollLeft in RTL contexts.
      var atStart = scrollLeft <= tolerance;
      var atEnd = scrollLeft >= maxScroll - tolerance;

      if (maxScroll <= tolerance) {
        prevBtn.disabled = true;
        nextBtn.disabled = true;
        return;
      }

      prevBtn.disabled = atStart;
      nextBtn.disabled = atEnd;
    }

    function onScroll() {
      if (rafId) return;
      rafId = requestAnimationFrame(function () {
        updateControls();
        rafId = null;
      });
    }

    prevBtn.addEventListener('click', function () {
      track.scrollBy({ left: -getStep(), behavior: 'smooth' });
    });

    nextBtn.addEventListener('click', function () {
      track.scrollBy({ left: getStep(), behavior: 'smooth' });
    });

    track.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);

    updateControls();
  }

  function init(root) {
    (root || document).querySelectorAll('.ztg').forEach(function (section) {
      initCarousel(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.ztg');
    if (section) initCarousel(section);
  });
})();
